module.exports = __webpack_public_path__ + "static/img/code2.5e507ee.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code2.jpeg
// module id = yl8n
// module chunks = 11